import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["src"];
import { onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    src: {
      type: String,
      required: true,
      default: ''
    },
    width: {
      type: String,
      default: '64px'
    },
    height: {
      type: String,
      default: '64px'
    },
    isShowBg: {
      type: Boolean,
      default: true
    }
  },

  setup(__props) {
    const props = __props;
    const url = ref('');
    const loading = ref(true);
    const showBg = ref(true);
    onMounted(() => {// let newImg = new Image()
      // newImg.src = props.src
      // newImg.onerror = () => { // 图片加载错误时的替换图片
      //     url.value = require("@/assets/imgs/picture_split.png")
      //     loading.value = false
      // }
      // newImg.onload = () => { // 图片加载成功后把地址给原来的img
      //     url.value = newImg.src
      //     loading.value = false
      // }
    });
    watch(() => props.src, val => {
      // if (val) {
      let newImg = new Image();
      newImg.src = props.src || '';

      newImg.onerror = () => {
        showBg.value = false;
        url.value = require("@/assets/imgs/picture_split.png");
        loading.value = false;
      };

      newImg.onload = () => {
        showBg.value = true;
        url.value = newImg.src;
        loading.value = false;
      }; // }

    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [loading.value ? _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        style: `width:${__props.width};height:${__props.height};`
      }, _ctx.$attrs, {
        "element-loading-background": "transparent"
      }), null, 16)), [[_directive_loading, loading.value]]) : _createCommentVNode("", true), !loading.value ? (_openBlock(), _createElementBlock("img", _mergeProps({
        key: 1,
        style: `width:${__props.width};height:${__props.height};${__props.isShowBg && showBg.value ? 'background-color: #B9D1D6' : ''}`
      }, _ctx.$attrs, {
        src: url.value
      }), null, 16, _hoisted_1)) : _createCommentVNode("", true)], 64);
    };
  }

});